import { Outlet } from 'react-router-dom';

import { Page } from '@common/ui/Page';
import TaskDrawer from '@MyTasks/organisms/TaskDrawer';
import routes from '@routes';

export default function TasksLayout() {
  return (
    <Page title={routes.Tasks.label}>
      <Outlet />
      <TaskDrawer />
    </Page>
  );
}
